// extracted by mini-css-extract-plugin
export default {"field":"SetJobZone_field__nNdMH","requiredIcon":"SetJobZone_requiredIcon__cXmcU"};